import { render, staticRenderFns } from "./ReclameAquiComplaintScore.vue?vue&type=template&id=b89a1bd6&"
import script from "./ReclameAquiComplaintScore.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiComplaintScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports